import { Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbTypeahead } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { Observable, OperatorFunction, Subject, merge } from 'rxjs';
import { debounceTime, distinctUntilChanged, filter, map } from 'rxjs/operators';
import { ModelHelpers } from '../../models/ModelHelpers';
import { Tecnico } from '../../models/tecnico-model';
import { AuthService } from '../../services/auth.service';
import { TecnicoService } from '../../services/tecnico.service';
import { TipoInmuebleService } from '../../services/tipo-inmueble.service';
import { UsuariosService } from '../../services/usuarios.service';
import { ValidadorServiceService } from '../../services/validador-service.service';
import { AdminUsuario } from '../../models/AdminUsuario';

@Component({
  selector: 'app-tecnico-edit',
  templateUrl: './tecnico-edit.component.html',
  styleUrls: ['./tecnico-edit.component.scss']
})
export class TecnicoEditComponent implements OnInit {

  tecnicoForm: FormGroup;
  title = 'Crear';
  isNewElement: boolean;
  id: number;
  isModal: boolean;
  errorMessage: any;
  tipologiaList: any = [];
  users: AdminUsuario[] = [];
  // Declarar una variable para rastrear si los datos se han cargado
  private dataLoaded = false;

  constructor(private _fb: FormBuilder, private _avRoute: ActivatedRoute, private _tecnicoService: TecnicoService,
    private _authService: AuthService, private _router: Router, public dialogRef: MatDialogRef<ValidadorServiceService>,
    private _location: Location, private _toastr: ToastrService, private _tipoInmueblesService: TipoInmuebleService,
    private _usuariosService: UsuariosService) {
    if (this._avRoute.snapshot.params['id']) {
      this.id = this._avRoute.snapshot.params['id'];
    }

    this.tecnicoForm = this._fb.group({
      id: 0,
      nombreCompleto: ['', [Validators.required]],
      email: ['', [Validators.required]],
      ciudad: [''],
      tipologiaID: [''],
      visitador: [false],
      activo: [true],
      userID: ['']
    });
  }

  get nombreCompleto() {
    return this.tecnicoForm.get('nombreCompleto');
  }

  get email() {
    return this.tecnicoForm.get('email');
  }

  ngOnInit() {
    this.loadData();
    this.loadCombo();
  }

  loadData() {
    if (this.id > 0) {
      this.isNewElement = false;
      this.title = 'Editar';
      this._tecnicoService.getTecnicoById(this.id)
        .subscribe(resp => {
          this.tecnicoForm.setValue(resp);
        }, error => {
          this.errorMessage = error;
        });
    } else {
      this.isNewElement = true;
    }
  }

  loadCombo() {
    this._tipoInmueblesService.getTipoInmuebles(false).subscribe(data => this.tipologiaList = data);
    this._usuariosService.getAllUsers().subscribe((data: AdminUsuario[]) => {
      this.users = data;
      this.dataLoaded = true;
      // Luego de cargar los datos, verifica si hay un usuario seleccionado y muestra su displayName
      this.showSelectedUser();
    })
  }

  closeDialog() {
    this.dialogRef.close();
  }

  cancel() {
    if (!this.isModal) {
      this._location.back();
    } else {
      this.closeDialog();
    }
  }

  save() {
    if (!this.tecnicoForm.valid) {
      this._toastr.error("Error")
      return;
    }
    let model = new Tecnico();
    ModelHelpers.copyFromForm(this.tecnicoForm.value, model);
    // console.log(model);

    if (this.isNewElement) {
      this._tecnicoService.post(this.tecnicoForm.value)
        .subscribe((data) => {
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
          this._toastr.success('Guardado')
        }, error => this.errorMessage = error);
    } else {
      this._tecnicoService.put(this.tecnicoForm.value)
        .subscribe((data) => {
          if (!this.isModal) {
            this._location.back();
          } else {
            this.closeDialog();
          }
          this._toastr.success('Guardado')
        }, error => {
          this.errorMessage = error;
          this._toastr.error(this.errorMessage);
        });
    }
  }

  displayFnUser = (item: any) => {
    if (!this.dataLoaded || !this.users) {
      return ''; // Valor por defecto
    }

    const user = this.users.find(user => user.id === item);
    return user ? user.displayName : '';
  }

  onClearUser() {
    this.tecnicoForm.patchValue({
      userID: ''
    })
  }

  showSelectedUser() {
    // Obtén el valor actual del control 'userID'
    const selectedUserId = this.tecnicoForm.get('userID').value;

    // Encuentra el usuario correspondiente
    const selectedUser = this.users.find(user => user.id === selectedUserId).id;

    // Si se encuentra el usuario, muestra su displayName
    if (selectedUser) {
      this.tecnicoForm.get('userID').setValue(selectedUser);
    }

  }
}
